import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { EncaminhamentoEspecializadoByIdQuery } from 'graphql/types.generated'
import { LotacaoContextModel } from 'hooks/atendimento-context/model-atendimentoContext'
import { LotacaoAtendimento } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { classificacaoRiscoRecord, EncaminhamentoExternoEspecializadoModel } from '../../model-encaminhamentoExterno'
import { EncaminhamentoExternoDetalhesPanelModel } from '../model'

function getHipoteseDiagnostica(cid?: CidSelectFieldModel): string | undefined {
  return cid?.nome && cid?.codigo ? `${cid.nome} - ${cid.codigo}` : cid?.nome ?? cid?.codigo ?? undefined
}

export function convertEncaminhamentoEspecializadoRecente(
  encaminhamento: EncaminhamentoExternoEspecializadoModel,
  lotacao: LotacaoAtendimento | LotacaoContextModel
): EncaminhamentoExternoDetalhesPanelModel | undefined {
  if (!encaminhamento) return undefined

  return {
    especialidade: encaminhamento.especialidadeSisreg?.descricao,
    complemento: encaminhamento.complemento,
    hipoteseDiagnostica: getHipoteseDiagnostica(encaminhamento.cidEncaminhamento),
    classificacaoRisco: classificacaoRiscoRecord[encaminhamento.classificacaoRiscoEncaminhamento]?.label,
    motivo: encaminhamento.motivoEncaminhamento,
    observacoes: encaminhamento.observacoes,
    lotacao: {
      nome: lotacao.profissional?.nome,
      cbo: lotacao.cbo?.nome,
      cns: lotacao.profissional?.cns,
      cpf: lotacao.profissional?.cpf,
    },
  }
}

export function convertEncaminhamentoEspecializado(
  encaminhamento: EncaminhamentoEspecializadoByIdQuery['encaminhamentoEspecializado']
): EncaminhamentoExternoDetalhesPanelModel | undefined {
  if (!encaminhamento) return undefined

  return {
    especialidade: encaminhamento.especialidadeSisreg?.descricao,
    complemento: encaminhamento.complemento,
    hipoteseDiagnostica: getHipoteseDiagnostica(encaminhamento.hipoteseDiagnosticoCid10),
    classificacaoRisco: classificacaoRiscoRecord[encaminhamento.classificacaoRiscoEncaminhamento]?.label,
    motivo: encaminhamento.motivoEncaminhamento,
    observacoes: encaminhamento.observacoes,
    lotacao: {
      nome: encaminhamento.atendimentoProfissional.lotacao.profissional?.nome,
      cpf: encaminhamento.atendimentoProfissional.lotacao.profissional?.cpf,
      cns: encaminhamento.atendimentoProfissional.lotacao.profissional?.cns,
      cbo: encaminhamento.atendimentoProfissional.lotacao.cbo?.nome,
    },
  }
}
